import type { LeaderboardStaticContent } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import { isContentType } from '../../utils/is-content-type';
import { MismatchedSlideTypePropertyError } from '../errors/mismatched-slide-type-property-error';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

const staticContentSchemaType: LeaderboardStaticContent['type'] = 'leaderboard';

export const getQuestionLeaderboardProperty = (
  target: CompatibilitySlide | VotingSlide,
  prop: keyof Question,
) => {
  const staticContents = target.staticContent;

  if (
    isContentType<LeaderboardStaticContent>(
      staticContents,
      staticContentSchemaType,
    )
  ) {
    switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
      case 'question':
        return target.title ?? '';
      case 'question_description':
        return staticContents.additionalDetails;
      case 'question_styled':
        return staticContents.styledTitle ?? {};
      default:
        return undefined;
    }
  }

  throw new MismatchedSlideTypePropertyError(
    staticContentSchemaType,
    target.staticContent.type,
  );
};
